import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import { MatTooltip } from '@angular/material/tooltip'
import {
  ElderAuditedEntityComponent,
  ElderDimensionsInputComponent,
  ElderHeaderComponent,
  ElderPaneContentComponent,
  ElderPaneSubtitleComponent,
  ElderQuantityInputControlComponent,
  ElderSelectComponent,
  ElderSinglePaneWrapperComponent,
  ElderToastService,
  ElderToolbarColumnDirective,
  ElderToolbarComponent,
  ElderToolbarService,
  ElderToolbarTitleService,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { OutputPreviewService } from '../../../../../output/preview/output-preview.service'
import { ReportSpec } from '../../../../../output/report/report-job'
import { Package, PackagingItem } from '../../../../../packages/package'
import { PackagePatch, PackagingItemPatchDto } from '../../../../../packages/package-patch'
import { PackageStateSelectDirective } from '../../../../../packages/package-state-select/package-state-select.directive'
import { PackageStorageLocationComponent } from '../../../../../packages/package-storage-location/package-storage-location.component'
import { PackageService } from '../../../../../packages/package.service'
import { PackagingMaterialTableComponent } from '../../../../../packages/packaging-material-table/packaging-material-table.component'
import { PackageTypeSelectDirective } from '../../../../../packages/types/package-type-select/package-type-select.directive'
import { PackagingGoodsComponent } from '../../../../../packages/packaging-goods/packaging-goods.component'

@Component({
  selector: 'app-terminal-order-package-detail',
  templateUrl: './terminal-order-package-detail.component.html',
  imports: [
    ElderSinglePaneWrapperComponent,
    ElderPaneSubtitleComponent,
    ElderPaneContentComponent,
    MatIconButton,
    MatIcon,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ElderSelectComponent,
    PackageTypeSelectDirective,
    PackageStateSelectDirective,
    ElderQuantityInputControlComponent,
    MatError,
    ElderValidationErrorDirective,
    ElderDimensionsInputComponent,
    ElderAuditedEntityComponent,
    MatTabGroup,
    MatTab,
    MatTooltip,
    PackagingMaterialTableComponent,
    ElderHeaderComponent,
    ElderTranslatePipe,
    ElderToolbarComponent,
    ElderToolbarColumnDirective,
    PackageStorageLocationComponent,
    PackagingGoodsComponent,
  ],
  providers: [ElderToolbarService, ElderToolbarTitleService],
})
export class TerminalOrderPackageDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  pkg = input.required<Package>()
  close = output<Event>()
  refresh = output<Package>()
  private packagePatch: PackagePatch
  private outputPreviewService = inject(OutputPreviewService)
  private packageService = inject(PackageService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    effect(() => {
      if (this.pkg()) {
        this.packagePatch = new PackagePatch(this.pkg().id)
      }
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  onSave(event: Event): void {
    PackagePatch.applyPackageData(this.packagePatch, this.pkg())
    this.packageService.updateByPatch(this.packagePatch).subscribe({
      next: (pkg) => {
        this.toastService.info('messages.persisting_successful')
        this.refresh.emit(pkg)
      },
      error: (err) => this.toastService.error('messages.saving_failed', err),
    })
  }

  onClose(event: Event): void {
    this.close.emit(event)
  }

  onPreviewPackageLabel(pkg: Package): void {
    this.outputPreviewService.openPreviewDialog(ReportSpec.packageLabels(pkg.id))
  }

  onPackagingItemsChange(items: PackagingItem[]): void {
    this.packagePatch.packagingItems = items.map(
      (item) => new PackagingItemPatchDto(item.material.materialId, item.material.quantity)
    )
  }
}
